/* global L */
import classNames from "classnames";

import MapElementImage from "./MapElementImage";
import calculateAnchorOffset from "../Utils/calculateAnchorOffset";

function iconHTML(iconStyle, backgroundStyle) {
  const backgroundHTML = renderImage(backgroundStyle);
  const iconHTML = renderImage(iconStyle);

  return `
    <div class="map-point">
      ${backgroundHTML}
      ${iconHTML}
    </div>
  `;
}

function renderImage(style) {
  if (!style) return "";

  const anchorPositions = calculateAnchorOffset(style);

  return MapElementImage({ ...style, ...anchorPositions });
}

function getMax(firstStyle, secondStyle, key) {
  const firstStyleSize = (firstStyle && firstStyle[key]) || 0;
  const secondStyleSize = (secondStyle && secondStyle[key]) || 0;

  return Math.max(firstStyleSize, secondStyleSize);
}

export default function MapElementIcon(style, options = {}) {
  const { iconStyle, backgroundStyle } = style;
  const className = classNames([
    "map-marker",
    "map-marker-informative",
    options.className
  ]);
  const height = getMax(iconStyle, backgroundStyle, "height");
  const tooltipAnchor = options.tooltipAnchor || [0, -height / 2];

  return L.divIcon({
    html: iconHTML(iconStyle, backgroundStyle),
    className: className,
    iconSize: [0, 0],
    iconAnchor: [0, 0],
    tooltipAnchor: tooltipAnchor
  });
}
